/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { SET_POLICY_ENTITIES_FORM_DATA, SET_ENTITIES_LIST, SET_POLICY_ENTITIES_FORM_ERROR, UPDATE_POLICY_ENTITIES_FORM_ERROR, RESET_POLICY_ENTITIES_FORM, SET_ENTITIES_ATTRIBUTES_LIST, ADD_ATTRIBUTE, SET_ATTRIBUTE_FORM_DATA, SET_ATTRIBUTE_ERROR_FORM_DATA, SET_RESOURCE_NS, SET_RESOURCES, ADD_COLUMN_ATTRIBUTE, SET_COLUMN_ATTRIBUTE_ERROR_FORM_DATA, SET_COLUMN_ATTRIBUTE_FORM_DATA, SET_DP_MODEL, RESET_ENTITY_POLICY_ATTRIBUTES, SET_ENTITIES_REMOTE_DATA_URL_OBJECT, SET_REMOTE_URL_RESPONSE_DATA, RESET_REMOTE_URL_RESPONSE_DATA } from './types';

export const policyEntityReducerInitialState: any = {
  entityFormData: {
    policyName: '',
    policyDescription: '',
    policyResource: '',
    policyNamespace: '',
    policyAction: []
  },
  entitiesList: [],
  entityFormError: {
    policyName: '',
    policyNamespace: '',
    policyResource: '',
    policyDescription: '',
    policyAction: '',
    policyEntityModel: ''
  },
  attributeList: [],
  attributes: [],
  attributesFormError: [],
  resourceNS: [],
  resources: [],
  resourcePagination: {
    pageNumber: 1,
    pageSize: 50,
    totalCount: 50,
  },
  dpModelList: {
    "model": "",
    "version": ""
  },
  columnAttributesList: [],
  columnAttributes: [],
  columnAttributesFormError: [],
  remoteDataUrlObject: {},
  remoteDataUrlResponse: {
    data: [],
    isPresent: false,
    pageNumber: 1,
    totalCount: 50,
  }
};

export const entityReducer = (state = policyEntityReducerInitialState, action: any) => {
  switch (action.type) {
    case SET_POLICY_ENTITIES_FORM_DATA:
      return {
        ...state,
        entityFormData: { ...state.entityFormData, ...action.data }
      }
    case SET_ENTITIES_LIST:
      return {
        ...state,
        entitiesList: action.entities
      }
    case SET_ENTITIES_ATTRIBUTES_LIST:
      return {
        ...state,
        attributeList: action.attributeList
      }
    case SET_POLICY_ENTITIES_FORM_ERROR:
      return {
        ...state,
        entityFormError: action.errorData
      }
    case UPDATE_POLICY_ENTITIES_FORM_ERROR:
      return {
        ...state,
        entityFormError: { ...state.entityFormError, ...action.data }
      }
    case RESET_POLICY_ENTITIES_FORM:
      return {
        ...state,
        ...policyEntityReducerInitialState
      }
    case ADD_ATTRIBUTE:
      return {
        ...state,
        attributes: [...state.attributes, action.attribute]
      }
    case RESET_ENTITY_POLICY_ATTRIBUTES:
      return {
        ...state,
        attributeList: [],
        attributes: [],
        columnAttributesList: [],
        columnAttributes: [],
      }
    case SET_ATTRIBUTE_FORM_DATA:
      return {
        ...state,
        attributes: action.attributes
      }
    case SET_ATTRIBUTE_ERROR_FORM_DATA:
      return {
        ...state,
        attributesFormError: action.attributesFormError
      }
    case ADD_COLUMN_ATTRIBUTE:
      return {
        ...state,
        columnAttributes: [...state.columnAttributes, action.columnAttribute]
      }
    case SET_COLUMN_ATTRIBUTE_FORM_DATA:
      return {
        ...state,
        columnAttributes: action.columnAttributes
      }
    case SET_COLUMN_ATTRIBUTE_ERROR_FORM_DATA:
      return {
        ...state,
        columnAttributesFormError: action.columnAttributesFormError
      }
    case SET_RESOURCE_NS:
      return {
        ...state,
        resourceNS: action.resourceNS
      }
    case SET_RESOURCES:
      {
        if (action.resourcePagination?.pageNumber < 2) {
          return {
            ...state,
            resources: action.resources,
            resourcePagination: action.resourcePagination
          }
        } else {
          const actionResources: any = action.resources || [];
          return {
            ...state,
            resources: [...state.resources, ...actionResources],
            resourcePagination: action.resourcePagination
          }
        }
      }
    case SET_DP_MODEL:
      return {
        ...state,
        dpModelList: action.dpModelList
      }
    case SET_ENTITIES_REMOTE_DATA_URL_OBJECT:
      return {
        ...state,
        remoteDataUrlObject: action.remoteDataUrlObject
      }
    case RESET_REMOTE_URL_RESPONSE_DATA: {
      return {
        ...state,
        remoteDataUrlResponse: {
          data: [],
          isPresent: action.isPresent,
          pageNumber: state.remoteDataUrlResponse.pageNumber,
          totalCount: state.remoteDataUrlResponse.totalCount,
        }
      }
    }
    case SET_REMOTE_URL_RESPONSE_DATA:
      {
        if (action.pageNumber < 2) {
          return {
            ...state,
            remoteDataUrlResponse: {
              data: action.data,
              isPresent: action.isPresent,
              pageNumber: action.pageNumber,
              totalCount: action.totalCount
            }
          }
        } else {
          return {
            ...state,
            remoteDataUrlResponse: {
              data: [...state.remoteDataUrlResponse.data, ...action.data],
              isPresent: action.isPresent,
              pageNumber: action.pageNumber,
              totalCount: action.totalCount,
            }
          }
        }
      }
    default:
      return state;
  }
}